export default __webpack_public_path__ + "static/intentIQ-556c28ddc438818c6b1362c0e66d6fb1.png";